import React, { useEffect, useState } from 'react';
import { Button, Space, Table, message } from 'antd';
import { Adminauthcontexthooks } from '../../Hooks/Adminauthcontexthooks';



const Miscformstable = () => {
    const columns = [
        {
            title: 'Year',
            dataIndex: 'UplaodingYear',
            key: 'UplaodingYear',
        },
        {
            title: 'Court',
            dataIndex: 'court',
            key: 'court',
        },
        {
            title: 'High Court',
            dataIndex: 'highcourt',
            key: 'highcourt',
        },
        {
            title: 'Sub Dist. Court',
            dataIndex: 'subdistcourt',
            key: 'subdistcourt',
        },
        {
            title: 'Form Type',
            dataIndex: 'formtype',
            key: 'formtype',
        },

        {
            title: 'Download File Link',
            dataIndex: 'Miscforms',
            key: 'Miscforms',
            render: text => (
                <a
                    // href={`https://cdr-backend.onrender.com/uploads/${text}`}
                    href={text}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View File
                </a>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (id, record) => (
                <Space size="middle">
                    <Button color="red" variant="dashed" onClick={() => DelMiscforms(id)} loading={subbtnloading} disabled={subbtnloading}>Delete</Button>
                </Space>
            ),
        },
    ];
    const { user } = Adminauthcontexthooks()
    const [data, setdata] = useState([]);
    const [loading, setloading] = useState(true);
    const [subbtnloading, setsubbtnloading] = useState(false);

    const GetMiscforms = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/miscforms', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }

        });
        const data = await res.json();
        if (res.status === 200) {
            setdata(data.MiscFormsOBJ);
            setloading(false);
        }
    }
    const DelMiscforms = async (obj) => {
        const id = obj._id
        const res = await fetch(`https://cdr-backend.onrender.com/delete/miscforms/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }
        });
        if (res.status === 200) {
            message.success("File deleted successfully");
            setsubbtnloading(false);
            GetMiscforms();
            return;
        } else {
            message.error("Something went wrong");
            setsubbtnloading(false);
            return;
        }
    }

    useEffect(() => {
        if (user) {
            const GetMiscforms = async () => {
                const res = await fetch('https://cdr-backend.onrender.com/get/miscforms', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }

                });
                const data = await res.json();
                if (res.status === 200) {
                    setdata(data.MiscFormsOBJ);
                    setloading(false);
                }
            }
            GetMiscforms()
        }

    }, [data, user])
    return (
        <>
            <Table columns={columns} dataSource={data} loading={loading} />
        </>
    )
}

export default Miscformstable;